import Utils from "../../../../hocs/utils/utils";

class NetworkHelper {
  async isConnected(retries = 5, delayMs = 1000): Promise<boolean> {
    if (!navigator.onLine) return false;

    for (let attempt = 0; attempt < retries; attempt++) {
      const reachable = await Utils.isNetworkReachable();
      if (reachable) return true;

      if (attempt < retries - 1) {
        await new Promise(res => setTimeout(res, delayMs));
      }
    }

    return false;
  }
}

export default new NetworkHelper();
